
import React from "react";
import { Link } from "react-router-dom";

function Breeding() {
  return (
    <>
      <section class="single section-sm pb-0">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="p-lg-5 p-4 bg-white">
                <h2 class="mb-5">Breeding</h2>
                <p>Breeding two Evos together is the only way to get new Evos.  Many factors go into what Evo you can expect to get when you breed.</p>
                <div class="content">
                <hr />
                <h5 class="mb-5">Breeding Requirements</h5>
                <p>More details coming soon!</p>
                <hr />
                <h5 class="mb-5">Egg Attributes and Probabilities</h5>
                <p>More details coming soon!</p>
                <hr />
                <h5 class="mb-5">Evo Attributes and Probabilities</h5>
                <p>More details coming soon!</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Breeding;